module.exports = __webpack_public_path__ + "img/power-sharing.82fc5921.png";